export const hasProjectIDInPath = ( pathParams: { [ key: string ]: unknown } ) => (
	!!pathParams.projectID
);

export const getIntegerParamFrom = ( pathParams: { [ key: string ]: unknown }, paramName: string ) => {
	const param = pathParams[ paramName ];

	if ( typeof param === 'number' ) return param;
	if ( typeof param === 'string' ) return parseInt( param, 10 );

	return undefined;
}

export const getProjectIDFrom = ( pathParams: { [ key: string ]: unknown } ) => {
	const projectID = getIntegerParamFrom( pathParams, 'projectID' );

	if ( !projectID ) throw new Error( 'Expected to find projectID in path parameters' );

	return projectID;
}
